import * as React from 'react'
import { useDispatch } from 'react-redux'
import { Box } from '@mui/material'
import { setANewFilterInList, removeFilterInList } from '../../redux/slices/Search/input'
import FilterButton from './FilterButton'

const Control = ({ type, isLastList: isAddButton, boxGrew, WIDTHMIN, ...rest }) => {
  const FISRT_ROW = 0
  const dispatch = useDispatch()
  const handleAddNewFilterButton = () => dispatch(setANewFilterInList(rest.idx))
  const handleRemoveFilterButton = () => {
    dispatch(removeFilterInList(rest.idx))
    rest.setEnableFilterButton(false)
  }

  const propsAddFilters = {
    add: isAddButton,
    onClick: isAddButton ? handleAddNewFilterButton : handleRemoveFilterButton,
    pl: 0.7,
  }
  const propsRMVFilters = {
    onClick: handleRemoveFilterButton,
    pl: 0.7,
  }

  console.log('rest.idx :>> ', rest.idx)
  console.log('rest :>> ', rest)
  console.log('rest.idx < rest.lengthList :>> ', rest.idx < rest.lengthList - 1)

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection:
          rest.windowWidth <= WIDTHMIN
            ? 'row-reverse'
            : boxGrew()
            ? 'column-reverse'
            : 'row-reverse',
        pt: rest.windowWidth > WIDTHMIN ? 0 : 1,
      }}>
      {type && Boolean(rest.idx < rest.nroOptsTypes) && (
        <FilterButton {...propsAddFilters} />
      )}
      {isAddButton && rest.idx !== FISRT_ROW ? (
        <FilterButton {...propsRMVFilters} />
      ) : null}
    </Box>
  )
}

export default Control
